export default __webpack_public_path__ + "static/slider5-80f8ecc78d8e3a39c5f56f5e7af0e316.jpg";